module.exports = __webpack_public_path__ + "static/media/light-mode.8fd04868.svg";